import { render, staticRenderFns } from "./ArchivedProjects.vue?vue&type=template&id=7077a069&scoped=true"
import script from "./ArchivedProjects.vue?vue&type=script&lang=js"
export * from "./ArchivedProjects.vue?vue&type=script&lang=js"
import style0 from "./ArchivedProjects.vue?vue&type=style&index=0&id=7077a069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7077a069",
  null
  
)

export default component.exports